import StorageKeys from '../storage/storageKeys';
export const getFTUEKey = (key) => `${StorageKeys.ftuePrefix.key}/${key}`;
export const isFTUEKey = (key) => key.startsWith(StorageKeys.ftuePrefix.key);
